import { Type, type Static } from '@sinclair/typebox';

export const CustomDomainApplicationStateSchema = Type.Object(
  {
    domain: Type.String(),
    enabled: Type.Boolean(),
  },
  { additionalProperties: false },
);

export const CustomDomainListSchema = Type.Object(
  {
    hosted_auth: Type.Array(Type.String()),
    tracking: Type.Array(Type.String()),
  },
  { additionalProperties: false },
);

export const ApplicationCustomDomainListSchema = Type.Object(
  {
    hosted_auth: Type.Array(CustomDomainApplicationStateSchema),
    tracking: Type.Array(CustomDomainApplicationStateSchema),
  },
  { additionalProperties: false },
);

export const CustomDomainResponseSchema = Type.Object(
  {
    success: Type.Boolean(),
    domain: Type.Optional(Type.String()),
  },
  { additionalProperties: false },
);

export type CustomDomainApplicationState = Static<typeof CustomDomainApplicationStateSchema>;
export type CustomDomainList = Static<typeof CustomDomainListSchema>;
export type ApplicationCustomDomainList = Static<typeof ApplicationCustomDomainListSchema>;
export type CustomDomainResponse = Static<typeof CustomDomainResponseSchema>;
